
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"modal dialog-error\">\n  <div class=\"message\">\n    <p>{{#t}}Hmm, we're having trouble with our system. We're working on fixing it for you and apologize for the inconvenience. Please try again later.{{/t}}</p>\n  </div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  